import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

interface Props {
  type?: 'submit' | 'button'
  color?: string
}
// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    type: { default: 'submit' },
    color: { default: 'primary' }
  },
  setup(__props: any) {

const props = __props as { type: 'submit' | 'button', color: string }



return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ class: "mt-1" }, props), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})